import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import { Button, Form, message, Upload, UploadProps, Modal, Empty, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import JutgeColors from "../../../../styles/JutgeColors";
import { InboxOutlined } from "@mui/icons-material";
import Editor from "@monaco-editor/react";
import { GetPractica } from "../../../../dao/jutge/GetPracticaId";
import { PostJutgePracticaIdUsuariIdMulti } from "../../../../dao/jutge/PostJutgePracticaIdUsuariIdMulti";
import { GetPracticaUsuarisEnviaments } from "../../../../dao/jutge/GetPracticaUsuarisEnviaments";
import { Collapse, Table, Tag, List, Typography } from "antd";
import { DeleteJutgePracticaFile } from "../../../../dao/jutge/DeleteJutgePracticaFile";
import ModoDesafioTag from "../../activitatsId/content/ModoDesafioTag";
import { GetPenalitzacionsPracticaUsuari } from "../../../../dao/jutge/GetPenalitzacionsPracticaUsuari";
import { Alert } from "antd";

const { Panel } = Collapse;
const { Title, Text } = Typography;

const PracticaIdEntrega = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const { id_practica } = useParams();
    const [dades, setDades] = useState<any>();
    const [selectedUids, setSelectedUids] = useState<string[]>([]);
    const navigate = useNavigate();
    const [enviado, setEnviado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isExam, setIsExam] = useState(false);
    const [enviaments, setEnviaments] = useState<any[]>([]);
    const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
    const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
    // Penalitzacions (pràctica, alumne) — font de veritat per a la nota efectiva i missatges.
    const [penalitzacions, setPenalitzacions] = useState<any[]>([]);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
            fetchEnviaments();
            fetchPenalitzacions();
        }
    }, [id_practica, isExam]);

    async function fetchPenalitzacions() {
        try {
            const data = await GetPenalitzacionsPracticaUsuari(id_practica + "", userId + "");
            setPenalitzacions(Array.isArray(data) ? data : []);
        } catch (e) {
            setPenalitzacions([]);
        }
    }

    // Nota efectiva (0-100) aplicant les penalitzacions sobre una nota base.
    const computeEffectiveNota = (baseNota: number): number => {
        if (!penalitzacions || penalitzacions.length === 0) return baseNota;
        let override: number | null = null;
        let totalAdjust = 0;
        for (const p of penalitzacions) {
            const tipus = String(p.tipus || 'ADJUST').toUpperCase();
            if (tipus === 'OVERRIDE') {
                const nf = p.nota_fixada != null ? Number(p.nota_fixada) : null;
                if (nf != null) override = (override == null) ? nf : Math.min(override, nf);
            } else if (p.valor != null) {
                totalAdjust += Number(p.valor);
            }
        }
        let r = override != null ? override : baseNota - totalAdjust;
        if (r < 0) r = 0;
        if (r > 100) r = 100;
        return r;
    };

    // Missatge de penalització per IA (si n'hi ha), per mostrar-lo a l'alumne.
    const iaPenalty = penalitzacions.find(p => Number(p.es_ia) === 1);

    async function fetchEnviaments() {
        const data = await GetPracticaUsuarisEnviaments(id_practica + "", userId + "");
        if (data) {
            // Sort by ID descending (newest first)
            const sorted = data.sort((a: any, b: any) => b.id - a.id);
            setEnviaments(sorted);
        }
    }


    async function checkDades() {
        setEnviado(true);
        setLoading(true);
        const data = await GetPractica(id_practica + "");

        /*if ((!data || (data.estat === 3)) && (user.tipus !== "0" && user.tipus !== "1")) {
            navigate(`/jutge/practiques`);
            return;
        }

         */

        setIsExam(data.isExam === 1);
        console.log(data);
        setDades(data);
        setLoading(false);
        setEnviado(false);
    }

    const { Dragger } = Upload;

    interface ExtendedFile extends File {
        uid: string;
    }


    const props: UploadProps = {
        name: 'file',
        multiple: true,
        fileList: uploadedFiles,
        onChange(info) {
            const { status } = info.file;
            setUploadedFiles(info.fileList);
            if (status !== 'uploading') {
                //console.log(info.file, info.fileList);
            }
            if (status === 'done') {
                message.success(`${info.file.name} uploaded successfully.`);
                // Add UID to list if not present
                if (info.file.response && info.file.response.uid) { // Wait, backend upload doesn't return UID? 
                    // No, backend PostJutgePracticaIdUsuariIsUpload returns 200 OK without body usually.
                    // But customRequest handles the upload.
                }
            } else if (status === 'error') {
                message.error(`${info.file.name} upload failed.`);
            }
        },
        onDrop(e) {
            // onDrop is redundant with customRequest usually handling things, but let's keep logic simple
            // Actually Dragger handles files.
        },
        customRequest: async ({ file, onSuccess, onError }) => {
            const uid = (file as any).uid; // AntD file has uid
            // We need to pass this UID to the backend upload endpoint so it keeps track of it?
            // The backend logic uses UID passed as param.
            // Line 85 in original code: formData.append('uid', selectedUid);
            // But here we have multiple files.

            // We should use the file's UID from AntD or generate one.
            // (file as any).uid corresponds to the unique id generated by AntD.
            // We will trust this UID and add it to our list.

            setSelectedUids(prev => {
                if (!prev.includes(uid)) return [...prev, uid];
                return prev;
            });

            const formData = new FormData();
            formData.append('file', file);
            formData.append('uid', uid);

            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}:8061/jutge/practica/${id_practica}/usuaris/${userId}/upload`, {
                    method: 'POST',
                    body: formData,
                });

                if (response.ok) {
                    if (onSuccess) onSuccess("ok");
                } else {
                    if (onError) onError(new Error("Upload failed"));
                }
            } catch (err) {
                if (onError) onError(new Error("Network error"));
            }
        },
        onRemove: async (file) => {
            const uid = (file as any).uid;

            // Remove from selectedUids
            setSelectedUids(prev => prev.filter(u => u !== uid));

            // Delete from backend
            try {
                await DeleteJutgePracticaFile(id_practica + "", userId + "", uid);
                message.success("Fitxer eliminat correctament");
            } catch (e) {
                console.error(e);
                message.error("Error al eliminar el fitxer del servidor");
                return false; // Prevent removal from list if failed? Usually better to allow logic removal but show error. 
                // AntD onRemove returning false stops removal effectively. 
                // But generally users want it gone from UI even if backend fails, though consistency is key.
                // Let's just warn and let it remove from UI.
            }
            return true;
        }
    };


    async function submitData() {
        if (selectedUids.length === 0) {
            message.warning("Has de pujar almenys un fitxer.");
            return;
        }

        setLoading(true);
        setEnviado(true);

        const isInIde = window.location.href.includes('isDesafio=true') || window.location.pathname.includes('/ide/') || window.self !== window.top;
        const origen = isInIde ? 'WEB_DESAFIO' : 'WEB_NORMAL';
        const response = await PostJutgePracticaIdUsuariIdMulti(id_practica + "", userId, selectedUids, origen);
        console.log("Submit multi response:", response);

        const respText = response?.response || "";
        const isSuccess = respText === "OK" ||
            respText.toLowerCase() === "ok" ||
            respText.startsWith("Tests ejecutados") ||
            (response && typeof response === 'object' && !response.error && respText !== "Incorrect");

        if (isSuccess) {
            message.success(respText.startsWith("Tests ejecutados") ? respText : "Entrega enviada i avaluada correctament");
        } else {
            message.warning(respText ? `Resultat: ${respText}` : "Entrega completada amb incidències");
        }

        // Always close modal, reset upload state and refresh submission history
        setIsUploadModalVisible(false);
        setUploadedFiles([]);
        setSelectedUids([]);
        await fetchEnviaments();

        setLoading(false);
        setEnviado(false);
    }

    // Helper to render JSON results
    const renderResults = (jsonString: string) => {
        if (!jsonString) return null;
        try {
            const data = JSON.parse(jsonString);

            // If it's the old format or new format? New format has: results: [], output: ...
            const results = data.results || [];

            const columns = [
                {
                    title: 'Test',
                    dataIndex: 'test',
                    key: 'test',
                    width: 220,
                    render: (test: string) => <Text strong>{test}</Text>
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                    key: 'status',
                    width: 100,
                    render: (status: string) => (
                        <Tag color={status === 'PASSED' ? 'green' : 'red'}>{status}</Tag>
                    )
                },
                {
                    title: 'Detall / Missatge',
                    dataIndex: 'message',
                    key: 'message',
                    render: (text: string, record: any) => {
                        const desc = text || record.description;
                        if (!desc) return <Text type="secondary">-</Text>;
                        return (
                            <div style={{
                                whiteSpace: 'pre-wrap',
                                fontFamily: 'monospace',
                                fontSize: '12px',
                                color: record.status === 'PASSED' ? '#389e0d' : '#cf1322',
                                background: record.status === 'PASSED' ? '#f6ffed' : '#fff1f0',
                                padding: '6px 10px',
                                borderRadius: 4,
                                border: `1px solid ${record.status === 'PASSED' ? '#b7eb8f' : '#ffa39e'}`,
                                maxHeight: 220,
                                overflowY: 'auto'
                            }}>
                                {desc}
                            </div>
                        );
                    }
                },
                {
                    title: 'Esperat',
                    dataIndex: 'expected',
                    key: 'expected',
                    width: 160,
                    render: (val: any) => {
                        if (!val || val === 'n/a' || val === '-') return <Text type="secondary">-</Text>;
                        return (
                            <div style={{
                                whiteSpace: 'pre-wrap',
                                fontFamily: 'monospace',
                                fontSize: '11px',
                                background: '#fafafa',
                                padding: '4px 6px',
                                borderRadius: 4,
                                maxHeight: 120,
                                overflowY: 'auto'
                            }}>
                                {String(val)}
                            </div>
                        );
                    }
                },
                {
                    title: 'Obtingut',
                    dataIndex: 'obtained',
                    key: 'obtained',
                    width: 160,
                    render: (val: any, record: any) => {
                        if (!val || val === 'n/a' || val === '-') return <Text type="secondary">-</Text>;
                        const isErr = record.status !== 'PASSED';
                        return (
                            <div style={{
                                whiteSpace: 'pre-wrap',
                                fontFamily: 'monospace',
                                fontSize: '11px',
                                background: isErr ? '#fff2f0' : '#fafafa',
                                color: isErr ? '#cf1322' : 'inherit',
                                padding: '4px 6px',
                                borderRadius: 4,
                                maxHeight: 120,
                                overflowY: 'auto'
                            }}>
                                {String(val)}
                            </div>
                        );
                    }
                },
            ];

            const notaRaw = typeof data.nota !== 'undefined' ? data.nota : null;
            // Base dels tests: preferim notaBase; nota efectiva = base + penalitzacions.
            const notaBase = typeof data.notaBase !== 'undefined' ? Number(data.notaBase)
                : (notaRaw !== null ? Number(notaRaw) : null);
            const nota = notaBase !== null ? computeEffectiveNota(notaBase) : null;

            return (
                <div style={{ marginTop: 10 }}>
                    <div style={{ marginBottom: 12, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                        <Tag color="blue">Tests totals: {data.testsFound}</Tag>
                        <Tag color="green">Correctes: {data.testsSucceeded}</Tag>
                        <Tag color="red">Incorrectes: {data.testsFailed}</Tag>
                        {nota !== null && (
                            <Tag color={Number(nota) >= 50 ? "success" : "error"} style={{ fontWeight: 'bold' }}>
                                Nota: {typeof nota === 'number' ? nota.toFixed(2) : nota}%
                            </Tag>
                        )}
                    </div>
                    {iaPenalty && (
                        <Alert
                            type="error"
                            showIcon
                            style={{ marginBottom: 12 }}
                            message="Ús d'IA generativa detectat"
                            description={iaPenalty.motiu}
                        />
                    )}
                    <Table
                        dataSource={results}
                        columns={columns}
                        pagination={false}
                        rowKey="test"
                        size="small"
                        bordered
                    />
                    {data.output && (
                        <div style={{ marginTop: 14 }}>
                            <Text strong style={{ fontSize: 12 }}>Sortida completa de la consola:</Text>
                            <div style={{ marginTop: 6, padding: 12, background: '#1e1e1e', color: '#d4d4d4', borderRadius: 4, maxHeight: 200, overflowY: 'auto' }}>
                                <Typography.Text style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', color: '#d4d4d4', fontSize: 12 }}>
                                    {data.output}
                                </Typography.Text>
                            </div>
                        </div>
                    )}
                </div>
            );
        } catch (e) {
            return <div>Error al processar els resultats de la pràctica</div>;
        }
    };

    return (
        <div style={{ padding: '8px 0', minHeight: '100%' }}>
            {/* Header with Title and '+' Nova Entrega button */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 12,
                paddingBottom: 16,
                marginBottom: 20,
                borderBottom: '1px solid #f0f0f0'
            }}>
                <div>
                    <h3 style={{ margin: 0, fontWeight: 700, color: '#1f1f1f' }}>
                        {dades?.nom || "Entrega de la pràctica"}
                    </h3>
                    <Text type="secondary" style={{ fontSize: 13 }}>
                        Historial d'enviaments realitzats i resultats d'avaluació
                    </Text>
                </div>

                {((dades?.estat === 3) || (user.tipus === "0" || user.tipus === "1")) && (
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        size="large"
                        style={{ backgroundColor: JutgeColors.colors.color6, borderRadius: 8, fontWeight: 600 }}
                        onClick={() => setIsUploadModalVisible(true)}
                    >
                        Nova Entrega
                    </Button>
                )}
            </div>

            {/* Avís destacat de detecció d'IA: visible nada més entrar, abans de l'historial */}
            {iaPenalty && (
                <Alert
                    type="error"
                    showIcon
                    banner
                    style={{ marginBottom: 20, borderRadius: 8 }}
                    message={<span style={{ fontWeight: 700 }}>Ús d'IA generativa detectat</span>}
                    description={iaPenalty.motiu}
                />
            )}

            {/* Submissions List */}
            {enviaments.length > 0 ? (
                <Collapse defaultActiveKey={[enviaments[0]?.id]} accordion style={{ background: '#fff', borderRadius: 8 }}>
                    {enviaments.map((env, index) => {
                        let parsed: any = {};
                        try {
                            parsed = env.json ? JSON.parse(env.json) : {};
                        } catch (e) {
                            parsed = {};
                        }
                        const notaRawPanel = typeof parsed.nota !== 'undefined' ? parsed.nota : null;
                        const notaBasePanel = typeof parsed.notaBase !== 'undefined' ? Number(parsed.notaBase)
                            : (notaRawPanel !== null ? Number(notaRawPanel) : null);
                        // Les penalitzacions (pràctica, alumne) s'apliquen a la nota VIGENT:
                        // només a l'enviament més recent (index 0). Els antics mostren la seva nota.
                        const nota = notaBasePanel !== null
                            ? (index === 0 ? computeEffectiveNota(notaBasePanel) : notaBasePanel)
                            : null;

                        return (
                            <Panel
                                header={
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingRight: 8 }}>
                                        <Space>
                                            <span style={{ fontWeight: 600 }}>{`Enviament #${env.id}`}</span>
                                            <ModoDesafioTag record={env} hideWhenPending />
                                            <Text type="secondary" style={{ fontSize: 12 }}>({env.moment})</Text>
                                        </Space>
                                        {nota !== null && (
                                            <Tag color={Number(nota) >= 50 ? "green" : "red"} style={{ fontWeight: 'bold' }}>
                                                Nota: {typeof nota === 'number' ? nota.toFixed(2) : nota}%
                                            </Tag>
                                        )}
                                    </div>
                                }
                                key={env.id}
                            >
                                {renderResults(env.json)}
                            </Panel>
                        );
                    })}
                </Collapse>
            ) : (
                <Empty
                    description={
                        (dades?.estat !== 3) && (user.tipus !== "0" && user.tipus !== "1")
                            ? "No s'admeten més entregues i no hi ha enviaments previs."
                            : "Encara no has realitzat cap enviament."
                    }
                    style={{ margin: '60px 0' }}
                >
                    {((dades?.estat === 3) || (user.tipus === "0" || user.tipus === "1")) && (
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => setIsUploadModalVisible(true)}
                            style={{ backgroundColor: JutgeColors.colors.color6, borderRadius: 6 }}
                        >
                            Fes la teva primera entrega
                        </Button>
                    )}
                </Empty>
            )}

            {/* Modal for New Submission */}
            <Modal
                title="Nova Entrega"
                open={isUploadModalVisible}
                onCancel={() => {
                    if (!enviado) setIsUploadModalVisible(false);
                }}
                footer={null}
                destroyOnClose
            >
                <div style={{ padding: '12px 0' }}>
                    <Form onFinish={submitData}>
                        <Form.Item
                            name="file"
                            rules={[{ required: true, message: 'Has de pujar almenys un fitxer!' }]}
                        >
                            <Dragger {...props} height={200}>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">Clica o arrossega fitxers '.java'</p>
                                <p className="ant-upload-hint">
                                    Pots pujar múltiples fitxers (Main.java, Classes.java, etc).
                                </p>
                            </Dragger>
                        </Form.Item>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 24 }}>
                            <Button onClick={() => setIsUploadModalVisible(false)} disabled={enviado}>
                                Cancel·lar
                            </Button>
                            <Button
                                type="primary"
                                style={{ backgroundColor: JutgeColors.colors.color6, borderColor: JutgeColors.colors.color6 }}
                                htmlType="submit"
                                loading={enviado}
                                disabled={selectedUids.length === 0}
                            >
                                Enviar Entrega
                            </Button>
                        </div>
                    </Form>
                </div>
            </Modal>
        </div>
    );
};

export default PracticaIdEntrega;
